import { memo } from "react";
import { MiStackedTypography } from "@miplatform/components";
import { DATE_TIME_FORMATS } from "@miplatform/constants";
import { formatDate } from "@miplatform/utils";
import { Box } from "@mui/material";
import { OrdersListActionMenu } from "../ActionMenu/OrdersListActionMenu";

/**
 * CompletedOrderActions Component
 *
 * A React functional component that displays the actions available for a completed order.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.completeDate - The completed date for the order.
 *
 * @returns {JSX.Element} The rendered CompletedOrderActions component.
 */
export const CompletedOrderActions = memo((props) => {
  const { completeDate } = props;

  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <MiStackedTypography
        title="Completed Date"
        description={
          completeDate
            ? formatDate(completeDate, DATE_TIME_FORMATS.FORMAT_MM_DD_YY)
            : "--"
        }
      />
      <OrdersListActionMenu
        menuViewConfig={{ OrderActivityDetails: true, UndoCompletion: true }}
        {...props}
      />
    </Box>
  );
});
